// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M16 2H8V5H5V9H19V5H16V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M2 11H22V22H16V16H8V22H2V11Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10 22V18H14V22H10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-building-3-filled')
export default class Building3FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'building-3-filled',
    }
  }
}
